import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/SAMainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة فاتورة الكهرباء في السعودية - احسب تكلفة استهلاكك الشهري";
const DESCRIPTION =
  "احسب قيمة فاتورة الكهرباء بدقة باستخدام التعريفة الرسمية لهيئة تنظيم الكهرباء. أدخل استهلاكك واحصل على حساب تفصيلي فوري للشرائح - أداة مجانية سهلة الاستخدام";
const KEYWORDS = "حاسبة فاتورة الكهرباء السعودية, حساب استهلاك الكهرباء, تعريفة الكهرباء السعودية, هيئة تنظيم الكهرباء, كيلووات ساعة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SA/calculators-list/electricity-calculator/";
// بيانات الأجهزة المنزلية
const APPLIANCES_DATA = {
  cooling: [
    { name: "مكيف سبليت 18000 وحدة", power: 1800, hours: 8, emoji: "❄️" },
    { name: "مكيف سبليت 24000 وحدة", power: 2400, hours: 8, emoji: "🌡️" },
    { name: "مكيف مركزي", power: 5000, hours: 10, emoji: "🏢" },
    { name: "مروحة سقف", power: 75, hours: 12, emoji: "🌀" },
  ],
  heating: [
    { name: "سخان ماء كهربائي", power: 2000, hours: 3, emoji: "💧" },
    { name: "سخان ماء فوري", power: 3000, hours: 1, emoji: "⚡" },
    { name: "دفاية كهربائية", power: 2000, hours: 4, emoji: "🔥" },
  ],
  kitchen: [
    { name: "ثلاجة عادية", power: 150, hours: 24, emoji: "🧊" },
    { name: "ثلاجة كبيرة (نوفروست)", power: 200, hours: 24, emoji: "❄️" },
    { name: "فرن كهربائي", power: 3000, hours: 1, emoji: "🍕" },
    { name: "ميكروويف", power: 1200, hours: 0.5, emoji: "🍲" },
    { name: "غلاية كهربائية", power: 1800, hours: 0.5, emoji: "☕" },
  ],
  laundry: [
    { name: "غسالة ملابس", power: 500, hours: 1.5, emoji: "👕" },
    { name: "نشافة ملابس", power: 3000, hours: 1, emoji: "🌪️" },
    { name: "مكواة", power: 1400, hours: 0.5, emoji: "👔" },
  ],
  electronics: [
    { name: "تلفزيون LED 55 بوصة", power: 100, hours: 6, emoji: "📺" },
    { name: "كمبيوتر مكتبي", power: 200, hours: 8, emoji: "🖥️" },
    { name: "لابتوب", power: 60, hours: 6, emoji: "💻" },
    { name: "راوتر إنترنت", power: 10, hours: 24, emoji: "📡" },
    { name: "بلايستيشن / إكس بوكس", power: 150, hours: 4, emoji: "🎮" },
  ],
  lighting: [
    { name: "مصباح LED 9 واط", power: 9, hours: 6, emoji: "💡" },
    { name: "مصباح عادي 60 واط", power: 60, hours: 6, emoji: "🔆" },
    { name: "إضاءة خارجية", power: 50, hours: 10, emoji: "🏮" },
  ]
};
function ElectricityCalculator() {
  const [consumption, setConsumption] = useState("");
  const [usageType, setUsageType] = useState("residential");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [applianceHours, setApplianceHours] = useState({});
  // التاريخ الحالي
  const today = new Date().toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const calculateBill = () => {
    try {
      setError("");
      const kwh = parseFloat(consumption);
      if (isNaN(kwh) || kwh <= 0) {
        setError("يرجى إدخال قيمة استهلاك صالحة");
        return;
      }
      let totalCost = 0;
      let tier1Cost = 0;
      let tier2Cost = 0;
      let tier3Cost = 0;
      let tier4Cost = 0;
      let tier5Cost = 0;
      let tier6Cost = 0;
      let tier1Kwh = 0;
      let tier2Kwh = 0;
      let tier3Kwh = 0;
      let tier4Kwh = 0;
      let tier5Kwh = 0;
      let tier6Kwh = 0;
      if (usageType === "residential") {
        // تعريفة سكنية - 6 شرائح حسب هيئة تنظيم الكهرباء
        if (kwh <= 2000) {
          tier1Kwh = kwh;
          tier1Cost = kwh * 0.05;
          totalCost = tier1Cost;
        } else if (kwh <= 4000) {
          tier1Kwh = 2000;
          tier2Kwh = kwh - 2000;
          tier1Cost = 2000 * 0.05;
          tier2Cost = (kwh - 2000) * 0.10;
          totalCost = tier1Cost + tier2Cost;
        } else if (kwh <= 6000) {
          tier1Kwh = 2000;
          tier2Kwh = 2000;
          tier3Kwh = kwh - 4000;
          tier1Cost = 2000 * 0.05;
          tier2Cost = 2000 * 0.10;
          tier3Cost = (kwh - 4000) * 0.20;
          totalCost = tier1Cost + tier2Cost + tier3Cost;
        } else if (kwh <= 7000) {
          tier1Kwh = 2000;
          tier2Kwh = 2000;
          tier3Kwh = 2000;
          tier4Kwh = kwh - 6000;
          tier1Cost = 2000 * 0.05;
          tier2Cost = 2000 * 0.10;
          tier3Cost = 2000 * 0.20;
          tier4Cost = (kwh - 6000) * 0.24;
          totalCost = tier1Cost + tier2Cost + tier3Cost + tier4Cost;
        } else if (kwh <= 8000) {
          tier1Kwh = 2000;
          tier2Kwh = 2000;
          tier3Kwh = 2000;
          tier4Kwh = 1000;
          tier5Kwh = kwh - 7000;
          tier1Cost = 2000 * 0.05;
          tier2Cost = 2000 * 0.10;
          tier3Cost = 2000 * 0.20;
          tier4Cost = 1000 * 0.24;
          tier5Cost = (kwh - 7000) * 0.26;
          totalCost = tier1Cost + tier2Cost + tier3Cost + tier4Cost + tier5Cost;
        } else {
          tier1Kwh = 2000;
          tier2Kwh = 2000;
          tier3Kwh = 2000;
          tier4Kwh = 1000;
          tier5Kwh = 1000;
          tier6Kwh = kwh - 8000;
          tier1Cost = 2000 * 0.05;
          tier2Cost = 2000 * 0.10;
          tier3Cost = 2000 * 0.20;
          tier4Cost = 1000 * 0.24;
          tier5Cost = 1000 * 0.26;
          tier6Cost = (kwh - 8000) * 0.30;
          totalCost = tier1Cost + tier2Cost + tier3Cost + tier4Cost + tier5Cost + tier6Cost;
        }
      } else if (usageType === "commercial") {
        // تعريفة تجارية
        totalCost = kwh * 0.16;
      } else {
        // تعريفة صناعية
        totalCost = kwh * 0.12;
      }
      setResult({
        totalCost,
        tier1Cost,
        tier2Cost,
        tier3Cost,
        tier4Cost,
        tier5Cost,
        tier6Cost,
        tier1Kwh,
        tier2Kwh,
        tier3Kwh,
        tier4Kwh,
        tier5Kwh,
        tier6Kwh,
        totalKwh: kwh
      });
    } catch (error) {
      setError("حدث خطأ في الحساب");
    }
  };
  const updateApplianceHours = (category, name, hours) => {
    const id = `${category}-${name}`;
    const updatedHours = {
      ...applianceHours,
      [id]: parseFloat(hours) || 0
    };
    setApplianceHours(updatedHours);
    let total = 0;
    Object.entries(APPLIANCES_DATA).forEach(([cat, appliances]) => {
      appliances.forEach(app => {
        const appId = `${cat}-${app.name}`;
        const hrs = updatedHours[appId] || 0;
        if (hrs > 0) {
          const daily = (app.power * hrs) / 1000;
          total += daily * 30;
        }
      });
    });
    if (total > 0) {
      setConsumption(total.toFixed(1));
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#006c35" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  احسب فاتورة الكهرباء بدقة وفقاً للتعريفة الرسمية المعتمدة من هيئة تنظيم
                  الكهرباء والإنتاج المزدوج (ECRA). أدخل استهلاكك الشهري بالكيلووات ساعة
                  واحصل على تفاصيل كاملة للفاتورة مع توزيع التكلفة على الشرائح الست.
                </p>
                <p>
                  تعتمد المملكة العربية السعودية نظام تسعير متدرج للكهرباء يهدف إلى تشجيع
                  الترشيد وتحقيق العدالة في التوزيع. النظام السكني مقسم إلى 6 شرائح، تبدأ
                  بـ 5 هللات للكيلووات في الشريحة الأولى وتصل إلى 30 هللة للاستهلاك المرتفع.
                  هذا التدرج يساعد الأسر على التحكم في فواتيرهم من خلال ترشيد الاستهلاك.
                </p>
                <p>
                  استخدم الأداة لحساب فاتورتك الشهرية وفهم توزيع التكاليف، أو احسب استهلاك
                  أجهزتك المنزلية من خلال قسم الأجهزة أدناه للحصول على صورة واضحة عن أكثر
                  الأجهزة استهلاكاً وكيفية تخفيض الفاتورة.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u><b>ملاحظة هامة</b>:</u>{" "}
                  <b>
                    تاريخ آخر تحديث: <time dateTime={new Date().toISOString().split('T')[0]}>{today}</time>
                  </b>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label><strong>نوع الاشتراك:</strong></label>
                    <select
                      className="form-control"
                      value={usageType}
                      onChange={(e) => setUsageType(e.target.value)}
                    >
                      <option value="residential">🏠 سكني (منزلي)</option>
                      <option value="commercial">🏢 تجاري</option>
                      <option value="industrial">🏭 صناعي</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="consumption"><strong>الاستهلاك الشهري (كيلووات ساعة):</strong></label>
                    <input
                      id="consumption"
                      type="number"
                      value={consumption}
                      onChange={(e) => setConsumption(e.target.value)}
                      className="form-control mb-2"
                      placeholder="مثال: 3500"
                    />
                  </div>
                  {usageType === "residential" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح السكنية:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px", fontSize: "13px" }}>
                        <li>الشريحة الأولى (0-2000): <strong>5 هللات/كيلووات</strong></li>
                        <li>الشريحة الثانية (2001-4000): <strong>10 هللات/كيلووات</strong></li>
                        <li>الشريحة الثالثة (4001-6000): <strong>20 هللة/كيلووات</strong></li>
                        <li>الشريحة الرابعة (6001-7000): <strong>24 هللة/كيلووات</strong></li>
                        <li>الشريحة الخامسة (7001-8000): <strong>26 هللة/كيلووات</strong></li>
                        <li>الشريحة السادسة (+8000): <strong>30 هللة/كيلووات</strong></li>
                      </ul>
                    </div>
                  )}
                  {usageType === "commercial" && (
                    <div className="alert alert-info">
                      <strong>🏢 التعريفة التجارية:</strong>
                      <p style={{ marginBottom: 0, marginTop: "10px" }}>
                        تعريفة موحدة: <strong>16 هللة/كيلووات</strong>
                      </p>
                    </div>
                  )}
                  {usageType === "industrial" && (
                    <div className="alert alert-info">
                      <strong>🏭 التعريفة الصناعية:</strong>
                      <p style={{ marginBottom: 0, marginTop: "10px" }}>
                        تعريفة موحدة: <strong>12 هللة/كيلووات</strong>
                      </p>
                    </div>
                  )}
                  <br />
                  <button
                    className="text-white"
                    style={{ fontSize: "20px", marginLeft: "10px", padding: "10px 30px", border: "none", borderRadius: "5px", backgroundColor: "#006c35" }}
                    onClick={calculateBill}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  result !== null && (
                    <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                      <p style={{ fontSize: "18px", marginBottom: "10px" }}>
                        <strong>💰 التكلفة الإجمالية: {result.totalCost.toFixed(2)} ريال</strong>
                      </p>
                      {usageType === "residential" && (
                        <div style={{ fontSize: "14px" }}>
                          {result.tier1Kwh > 0 && (
                            <p style={{ marginBottom: "5px" }}>
                              الشريحة 1: {result.tier1Kwh.toLocaleString()} كيلووات × 0.05 = {result.tier1Cost.toFixed(2)} ريال
                            </p>
                          )}
                          {result.tier2Kwh > 0 && (
                            <p style={{ marginBottom: "5px" }}>
                              الشريحة 2: {result.tier2Kwh.toLocaleString()} كيلووات × 0.10 = {result.tier2Cost.toFixed(2)} ريال
                            </p>
                          )}
                          {result.tier3Kwh > 0 && (
                            <p style={{ marginBottom: "5px" }}>
                              الشريحة 3: {result.tier3Kwh.toLocaleString()} كيلووات × 0.20 = {result.tier3Cost.toFixed(2)} ريال
                            </p>
                          )}
                          {result.tier4Kwh > 0 && (
                            <p style={{ marginBottom: "5px" }}>
                              الشريحة 4: {result.tier4Kwh.toLocaleString()} كيلووات × 0.24 = {result.tier4Cost.toFixed(2)} ريال
                            </p>
                          )}
                          {result.tier5Kwh > 0 && (
                            <p style={{ marginBottom: "5px" }}>
                              الشريحة 5: {result.tier5Kwh.toLocaleString()} كيلووات × 0.26 = {result.tier5Cost.toFixed(2)} ريال
                            </p>
                          )}
                          {result.tier6Kwh > 0 && (
                            <p style={{ marginBottom: "5px" }}>
                              الشريحة 6: {result.tier6Kwh.toLocaleString()} كيلووات × 0.30 = {result.tier6Cost.toFixed(2)} ريال
                            </p>
                          )}
                        </div>
                      )}
                      {usageType === "commercial" && (
                        <div style={{ fontSize: "14px" }}>
                          <p>
                            تعريفة موحدة: {result.totalKwh.toLocaleString()} كيلووات × 0.16 = {result.totalCost.toFixed(2)} ريال
                          </p>
                        </div>
                      )}
                      {usageType === "industrial" && (
                        <div style={{ fontSize: "14px" }}>
                          <p>
                            تعريفة موحدة: {result.totalKwh.toLocaleString()} كيلووات × 0.12 = {result.totalCost.toFixed(2)} ريال
                          </p>
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
              <div className="col-sm-12 col-md-5">
                {/* جدول الأسعار الرسمية */}
                <div className="calculatorStyle">
                  <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                    <h3 style={{ fontSize: "16px", margin: 0 }}>📋 جدول الأسعار الرسمية</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <strong>🏠 الاستخدام السكني</strong>
                      <table className="table table-sm mt-2 table-bordered" style={{ fontSize: "13px" }}>
                        <thead className="table-light">
                          <tr>
                            <th>الشريحة</th>
                            <th>السعر</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>0-2,000 كيلووات</td>
                            <td><strong>5 هللات</strong></td>
                          </tr>
                          <tr>
                            <td>2,001-4,000</td>
                            <td><strong>10 هللات</strong></td>
                          </tr>
                          <tr>
                            <td>4,001-6,000</td>
                            <td><strong>20 هللة</strong></td>
                          </tr>
                          <tr>
                            <td>6,001-7,000</td>
                            <td><strong>24 هللة</strong></td>
                          </tr>
                          <tr>
                            <td>7,001-8,000</td>
                            <td><strong>26 هللة</strong></td>
                          </tr>
                          <tr>
                            <td>أكثر من 8,000</td>
                            <td><strong>30 هللة</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="mb-3">
                      <strong>🏢 الاستخدام التجاري</strong>
                      <table className="table table-sm mt-2 table-bordered" style={{ fontSize: "13px" }}>
                        <tbody>
                          <tr>
                            <td>جميع الاستهلاك</td>
                            <td><strong>16 هللة/كيلووات</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <strong>🏭 الاستخدام الصناعي</strong>
                      <table className="table table-sm mt-2 table-bordered" style={{ fontSize: "13px" }}>
                        <tbody>
                          <tr>
                            <td>جميع الاستهلاك</td>
                            <td><strong>12 هللة/كيلووات</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                {/* أمثلة سريعة */}
                <div className="calculatorStyle">
                  <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                    <h3 style={{ fontSize: "16px", margin: 0 }}>🧮 أمثلة سريعة (سكني)</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-2 p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>1,500 كيلووات:</strong>
                      <br />
                      1,500 × 0.05 = <strong>75 ريال</strong>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>3,000 كيلووات:</strong>
                      <br />
                      (2,000 × 0.05) + (1,000 × 0.10) = <strong>200 ريال</strong>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>5,000 كيلووات:</strong>
                      <br />
                      (2,000 × 0.05) + (2,000 × 0.10) + (1,000 × 0.20) = <strong>500 ريال</strong>
                    </div>
                    <div className="p-2" style={{ border: "2px solid #006c35", borderRadius: "5px" }}>
                      <strong>10,000 كيلووات:</strong>
                      <br />
                      100 + 200 + 400 + 240 + 260 + 600 = <strong>1,800 ريال</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* قسم حساب الاستهلاك من الأجهزة */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                  <h2 style={{ fontSize: "16px", margin: 0 }}>
                    🔌 احسب استهلاكك من أجهزتك المنزلية
                  </h2>
                </div>
                <div className="p-3">
                  <p>حدد ساعات تشغيل أجهزتك اليومية وسيتم حساب الاستهلاك والتكلفة تلقائياً</p>
                  {Object.entries(APPLIANCES_DATA).map(([category, appliances]) => (
                    <div key={category} className="mb-4">
                      <h3 className="bg-success text-white text-center">
                        {category === 'cooling' && '❄️ التبريد والتكييف'}
                        {category === 'heating' && '🔥 التسخين والتدفئة'}
                        {category === 'kitchen' && '🍳 أجهزة المطبخ'}
                        {category === 'laundry' && '🧺 الغسيل والعناية'}
                        {category === 'electronics' && '📺 الإلكترونيات'}
                        {category === 'lighting' && '💡 الإضاءة'}
                      </h3>
                      <div className="row">
                        {appliances.map((app) => {
                          const id = `${category}-${app.name}`;
                          const hours = applianceHours[id] || 0;
                          const monthly = hours > 0 ? ((app.power * hours) / 1000) * 30 : 0;
                          // حساب التكلفة حسب الشرائح
                          let cost = 0;
                          if (monthly <= 2000) {
                            cost = monthly * 0.05;
                          } else if (monthly <= 4000) {
                            cost = (2000 * 0.05) + ((monthly - 2000) * 0.10);
                          } else if (monthly <= 6000) {
                            cost = (2000 * 0.05) + (2000 * 0.10) + ((monthly - 4000) * 0.20);
                          } else if (monthly <= 7000) {
                            cost = (2000 * 0.05) + (2000 * 0.10) + (2000 * 0.20) + ((monthly - 6000) * 0.24);
                          } else if (monthly <= 8000) {
                            cost = (2000 * 0.05) + (2000 * 0.10) + (2000 * 0.20) + (1000 * 0.24) + ((monthly - 7000) * 0.26);
                          } else {
                            cost = (2000 * 0.05) + (2000 * 0.10) + (2000 * 0.20) + (1000 * 0.24) + (1000 * 0.26) + ((monthly - 8000) * 0.30);
                          }
                          return (
                            <div className="col-sm-12 col-md-4 mb-3" key={id}>
                              <div style={{ minHeight: "180px", border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                                <div className="p-2 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                                  <strong style={{ fontSize: "14px" }}>{app.emoji} {app.name}</strong>
                                </div>
                                <div className="p-3">
                                  <small className="text-muted d-block mb-2">
                                    القدرة: {app.power} واط
                                  </small>
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: "12px" }}>ساعات التشغيل يومياً:</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={hours || ''}
                                      onChange={(e) => updateApplianceHours(category, app.name, e.target.value)}
                                      placeholder={`مثال: ${app.hours}`}
                                      min="0"
                                      step="0.5"
                                    />
                                  </div>
                                  {hours > 0 && (
                                    <div className="d-block" style={{ color: "#006c35" }}>
                                      <small>
                                        الاستهلاك: <strong>{monthly.toFixed(1)} كيلووات/شهر</strong>
                                      </small>
                                      <br />
                                      <small>
                                        التكلفة التقريبية: <strong>{cost.toFixed(2)} ريال</strong>
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <hr />
            {/* نصائح التوفير */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 text-white" style={{ backgroundColor: "#006c35" }}>
                  <h2 style={{ fontSize: "16px", margin: 0 }}>💡 نصائح لتوفير الكهرباء في المناخ السعودي</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>رفع درجة المكيف إلى 24°م</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            رفع الحرارة من 20 إلى 24 درجة يوفر 40% من استهلاك المكيف، أي حوالي 300-400 ريال شهرياً في الصيف
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>عزل الأسطح والجدران</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            العزل الحراري الجيد يقلل حمل التكييف بنسبة 30-50%، مع استرداد التكلفة خلال سنتين من التوفير
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>نظف فلاتر المكيف شهرياً</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الفلاتر المتسخة تزيد استهلاك المكيف بنسبة 15%، والتنظيف الدوري يحافظ على الكفاءة ويطيل عمر الجهاز
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>استخدم السخان الشمسي</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            السخان الشمسي يوفر 80% من تكلفة تسخين الماء، أي حوالي 100-150 ريال شهرياً في المتوسط
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>استبدل المصابيح بـ LED</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            مصابيح LED توفر 80% من استهلاك المصابيح العادية وتدوم 10 مرات أطول، موفرة 30-50 ريال شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>أطفئ الأجهزة بالكامل</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الأجهزة في وضع الاستعداد تستهلك 5-10% من فاتورتك، فصلها يوفر 50-100 ريال شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>استخدم مكيفات انفرتر</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            مكيفات الانفرتر توفر 30-50% من استهلاك المكيفات العادية، موفرة 200-400 ريال شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #006c35", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="p-2 text-white" style={{ backgroundColor: "#006c35" }}>
                          <strong style={{ fontSize: "14px" }}>صيانة دورية للمكيفات</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الصيانة السنوية للمكيفات تحسن الكفاءة بنسبة 20% وتمنع الأعطال المكلفة
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* الأسئلة الشائعة */}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيف يتم احتساب فاتورة الكهرباء في السعودية؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نظام الشرائح الست للاستخدام السكني</h2>
                  </u>
                  <p>
                    تعتمد المملكة نظام تسعير متدرج وفق هيئة تنظيم الكهرباء (ECRA). الاستهلاك
                    مقسم إلى 6 شرائح تبدأ من 5 هللات للكيلووات وتصل إلى 30 هللة للاستهلاك
                    المرتفع، مما يشجع على الترشيد.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال حسابي</h2>
                  </u>
                  <p>
                    إذا كان استهلاكك 5,000 كيلووات/ساعة شهرياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    الشريحة 1: 2,000 × 0.05 = 100 ريال
                    <br />
                    الشريحة 2: 2,000 × 0.10 = 200 ريال
                    <br />
                    الشريحة 3: 1,000 × 0.20 = 200 ريال
                    <br />
                    <strong>الإجمالي: 500 ريال</strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">لماذا فاتورتي مرتفعة في الصيف؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسباب الرئيسية</h2>
                  </u>
                  <p>
                    • المكيفات تستهلك 60-70% من الفاتورة الصيفية
                    <br />
                    • درجات الحرارة المرتفعة تزيد حمل التكييف
                    <br />
                    • المكيفات القديمة تستهلك ضعف الموديلات الحديثة
                    <br />
                    • العزل الضعيف يضاعف استهلاك التبريد
                    <br />
                    • تشغيل المكيفات على درجات منخفضة جداً (16-18°)
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كم تكلفة تشغيل المكيف شهرياً؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>حسابات تقريبية</h2>
                  </u>
                  <p>
                    مكيف سبليت 18000 وحدة (1.8 كيلووات) يعمل 8 ساعات يومياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    الاستهلاك الشهري: 1.8 × 8 × 30 = 432 كيلووات
                    <br />
                    التكلفة: (2,000 × 0.05) + (2,000 × 0.10) + (432 - 4,000 لا ينطبق)
                    <br />
                    تقريباً: <strong>300-350 ريال شهرياً</strong>
                    <br />
                    <small>ملاحظة: الاستهلاك الفعلي يعتمد على كفاءة الجهاز والعزل</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أحسب استهلاك جهاز معين؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>المعادلة الأساسية</h2>
                  </u>
                  <p>
                    الاستهلاك الشهري (كيلووات) = (القدرة بالواط × الساعات يومياً ÷ 1000) × 30
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال: سخان ماء</h2>
                  </u>
                  <p>
                    سخان 2000 واط يعمل 3 ساعات يومياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    (2000 × 3 ÷ 1000) × 30 = 180 كيلووات شهرياً
                    <br />
                    التكلفة: 180 × 0.05 = <strong>9 ريالات تقريباً</strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما الفرق بين التعريفة السكنية والتجارية؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الفروقات الأساسية</h2>
                  </u>
                  <p>
                    • السكنية: نظام متدرج (6 شرائح) من 5-30 هللة
                    <br />
                    • التجارية: تعريفة موحدة 16 هللة للكيلووات
                    <br />
                    • الصناعية: تعريفة موحدة 12 هللة للكيلووات
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>مثال:</strong> استهلاك 3000 كيلووات
                    <br />
                    سكني: 200 ريال (متدرج)
                    <br />
                    تجاري: 480 ريال (16 × 3000)
                    <br />
                    صناعي: 360 ريال (12 × 3000)
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">هل يوجد رسوم إضافية على الفاتورة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مكونات الفاتورة</h2>
                  </u>
                  <p>
                    بالإضافة إلى قيمة الاستهلاك، قد تشمل الفاتورة:
                    <br />
                    • رسوم الخدمة الشهرية (ثابتة)
                    <br />
                    • رسوم صيانة العداد
                    <br />
                    • ضريبة القيمة المضافة 15%
                    <br />
                    • قراءة العداد والفواتير السابقة
                  </p>
                  <div className="p-3 mb-2 bg-warning text-black">
                    <strong>ملاحظة:</strong> الأسعار المذكورة في هذه الحاسبة هي تعريفة
                    الاستهلاك فقط ولا تشمل الرسوم الإضافية وضريبة القيمة المضافة
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أخفض فاتورتي إلى أقل من 200 ريال؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>استراتيجية التوفير</h2>
                  </u>
                  <p>
                    للبقاء أقل من 200 ريال، يجب أن يكون استهلاكك أقل من 3000 كيلووات:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    • استخدم المكيف 6 ساعات يومياً بدلاً من 10 (توفير 400 كيلووات)
                    <br />
                    • ارفع حرارة المكيف إلى 24-25° (توفير 30%)
                    <br />
                    • استخدم سخان شمسي (توفير 180 كيلووات)
                    <br />
                    • استبدل المصابيح بـ LED (توفير 50 كيلووات)
                    <br />
                    • افصل الأجهزة غير المستخدمة (توفير 100 كيلووات)
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ElectricityCalculator;